// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui';
import './assets/css/common.css'
import './assets/css/iconfont.css';
import './assets/css/main.css';
import App from './App'
import router from './router'
ElementUI.Dialog.props.closeOnClickModal.default = false
Vue.config.productionTip = false

Vue.use(ElementUI);

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js